{
  "title": "報名資料頁欄位參考",
  "description": "「報名資料」頁的欄位定義與可用篩選條件，以及「需補填的報名資料」區塊；隊伍清單為唯讀檢視，不影響報名完成度判定。",
  "headings": ["欄位說明", "可用篩選條件"],
  "intro": "「資料」分組下的「報名資料」頁列出所有隊伍的報名表填答狀態與最後修改時間，下方的隊伍清單僅供查看，不提供編輯或審核操作。報名完成度與資格驗證狀態是完全獨立的兩條軸，本頁顯示的完成狀態一律不反映、也不會被資格驗證結果影響。頁面最上方另有「需補填的報名資料」區塊：列出已完成報名、但已儲存的答案不符合目前已發布表單的學生（姓名、隊伍、尚需補填的欄位，不含 Email 與答案），沒有人需要補填時不顯示；具備隊伍管理權限的人可以在此「寄測試信給我自己」，或「傳送補填提醒」（先顯示人數與信件預覽，確認後才寄給該學生本人）。本頁不會替學生填寫或修改任何報名資料。",
  "submissionSectionHeading": "欄位說明",
  "submissionStatuses": [
    { "name": "隊伍", "editable": "隊伍名稱。" },
    { "name": "隊長", "editable": "隊長顯示名稱與 Email。" },
    {
      "name": "表單版本",
      "editable": "該隊伍填答時所使用的報名表版本編號；若尚未有版本紀錄則顯示「無版本」。"
    },
    { "name": "完成狀態", "editable": "報名表是否已填寫完成，僅「已完成」或「未完成」兩種徽章。" },
    {
      "name": "最後修改時間",
      "editable": "該隊伍報名資料最後一次異動的時間；若尚無資料則顯示為空白符號。"
    },
    {
      "name": "操作",
      "editable": "僅「已完成」的隊伍會顯示「檢視填答內容」按鈕，點擊後以彈出視窗唯讀呈現該隊伍完整的表單答案、表單版本編號、提交時間與最後更新時間。"
    }
  ],
  "judgeSectionHeading": "可用篩選條件",
  "judgeStatuses": [
    { "name": "依完成狀態篩選", "description": "只顯示「已完成」或「未完成」的隊伍。" },
    { "name": "依隊伍 ID 篩選", "description": "輸入隊伍 ID 文字進行篩選。" },
    {
      "name": "文字搜尋",
      "description": "依隊伍或隊長相關文字搜尋，篩選條件皆會保留在網址列，方便分享或重新整理後仍維持原本的查詢結果。"
    }
  ]
}
